var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-sheet",
    {
      class: [
        _vm.data.centered ? "text-center" : "",
        !_vm.noPageTitle ? "page-title" : "",
      ],
      attrs: { color: "transparent", "max-width": _vm.maxWidth },
    },
    [
      !_vm.noPageTitle
        ? _c("div", { staticClass: "py-7 d-none d-lg-block" })
        : _vm._e(),
      !_vm.noPageTitle
        ? _c("div", { staticClass: "py-4 d-block d-lg-none" })
        : _vm._e(),
      _vm.data.toptitle
        ? _c(
            "div",
            {
              staticClass:
                "top-title text-uppercase font-weight-bold grey--text text--lighten-1 mb-2",
              class: _vm.data.textProps,
            },
            [_vm._v(" " + _vm._s(_vm.data.toptitle) + " ")]
          )
        : _vm._e(),
      _c(
        "v-sheet",
        {
          class: _vm.data.centered ? "mx-auto" : "",
          attrs: {
            "max-width": _vm.data.titleMaxWidth
              ? _vm.data.titleMaxWidth
              : "450px",
            color: "transparent",
          },
        },
        [
          _vm.data.title
            ? _c("h1", { class: _vm.data.textProps }, [
                _vm._v(" " + _vm._s(_vm.data.title) + " "),
              ])
            : _vm._e(),
        ]
      ),
      _c("div", { staticClass: "mt-3" }),
      _c(
        "v-sheet",
        {
          class: _vm.data.centered ? "mx-auto" : "",
          attrs: {
            "max-width": _vm.data.descriptionMaxWidth,
            color: "transparent",
          },
        },
        [
          _vm.data.description
            ? _c("h5", { staticClass: "ma-0", class: _vm.data.textProps }, [
                _vm._v(" " + _vm._s(_vm.data.description) + " "),
              ])
            : _vm._e(),
          _c("div", [_vm._t("default")], 2),
        ]
      ),
      !_vm.noPageTitle ? _c("div", { staticClass: "py-6" }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }